import { render, staticRenderFns } from "./AlarmRecord.vue?vue&type=template&id=a1117b5a&scoped=true"
import script from "./AlarmRecord.vue?vue&type=script&lang=js"
export * from "./AlarmRecord.vue?vue&type=script&lang=js"
import style0 from "./AlarmRecord.vue?vue&type=style&index=0&id=a1117b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1117b5a",
  null
  
)

export default component.exports